const SERVICE_TYPE_DISPLAY_LABELS: Record<string, string> = {
  'Remote Captioning': 'Remote Captioning - Human',
  'Video Remote Interpreting (VRI)': 'Video Remote Interpreting (VRI) - Human',
  'Remote Text Interpreting (RTI)': 'Remote Text Interpreting (RTI) - Human',
  'Notetaking': 'Notetaking - Human',
  'On-site Captioning': 'On-site Captioning - Human',
  'Google Event - Remote Captioning': 'Google Event - Remote Captioning - Human',
  'Google Event - Video Relay Interpreting': 'Google Event - Video Relay Interpreting - Human',
  'Ai-Live Lexi': 'Ai-Live LEXI',
};

export function serviceTypeDisplayLabel(name: string): string {
  return SERVICE_TYPE_DISPLAY_LABELS[name] ?? name;
}
